module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/sl-f1772cd4436de4f4535ad8725adbd85d.svg";